<div class="super-admin-padding">
  <div class="super-admin-page theme-background-color">
    <div class="super-admin-header">Super admin</div>
    <h1>Org detail</h1>

    <div *ngIf="org">
      <p>Name: {{ org.name }}</p>
      <p>Account ID: {{ org._id }}</p>
      <!-- <p>Super admins: {{ account.superAdmins }}</p> -->
      <p>Created: {{ org.createdAtString }}</p>
      <p>Updated: {{ org.updatedAtString }}</p>

      <mat-divider></mat-divider>
      <h3>Users</h3>

      <table mat-table [dataSource]="org.users" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <!-- Admin Column -->
        <ng-container matColumnDef="admin">
          <th mat-header-cell *matHeaderCellDef>Admin</th>
          <td mat-cell *matCellDef="let element">
            {{ element.admin ? 'Admin' : '' }}
          </td>
        </ng-container>

        <!-- Spaces Column -->
        <ng-container matColumnDef="userSpaces">
          <th mat-header-cell *matHeaderCellDef>Spaces</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngFor="let s of element.userSpaces">
              <a href="#{{ s.href }}"> {{ s.name }} </a> <br />
            </ng-container>
          </td>
        </ng-container>

        <!-- createdAt Column -->
        <ng-container matColumnDef="createdAtString">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAtString }}
          </td>
        </ng-container>

        <!-- updatedAt Column -->
        <ng-container matColumnDef="updatedAtString">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAtString }}
          </td>
        </ng-container>

        <!-- archivedAt Column -->
        <ng-container matColumnDef="archivedAtString">
          <th mat-header-cell *matHeaderCellDef>Archived</th>
          <td mat-cell *matCellDef="let element">
            {{ element.archivedAtString }}
          </td>
        </ng-container>

        <!-- _id Column -->
        <ng-container matColumnDef="_id">
          <th mat-header-cell *matHeaderCellDef>id</th>
          <td mat-cell *matCellDef="let element">{{ element._id }}</td>
        </ng-container>

        <!-- accountId Column -->
        <ng-container matColumnDef="accountId">
          <th mat-header-cell *matHeaderCellDef>Account ID</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="element.accountLink">{{ element.accountId }}</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="userDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: userDisplayedColumns"></tr>
      </table>

      <mat-divider></mat-divider>

      <h3>Spaces</h3>

      <table mat-table [dataSource]="org.spaces" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Users Column -->
        <ng-container matColumnDef="users">
          <th mat-header-cell *matHeaderCellDef>Users</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngFor="let s of element.users">
              <a href="#{{ s.href }}"> {{ s.name }} </a> <br />
            </ng-container>
          </td>
        </ng-container>

        <!-- taskNumber Column -->
        <ng-container matColumnDef="taskNumber">
          <th mat-header-cell *matHeaderCellDef>Task number</th>
          <td mat-cell *matCellDef="let element">
            {{ element.taskNumber }}
          </td>
        </ng-container>

        <!-- createdAt Column -->
        <ng-container matColumnDef="createdAtString">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAtString }}
          </td>
        </ng-container>

        <!-- updatedAt Column -->
        <ng-container matColumnDef="updatedAtString">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAtString }}
          </td>
        </ng-container>

        <!-- archivedAt Column -->
        <ng-container matColumnDef="archivedAtString">
          <th mat-header-cell *matHeaderCellDef>Archived</th>
          <td mat-cell *matCellDef="let element">
            {{ element.archivedAtString }}
          </td>
        </ng-container>

        <!-- _id Column -->
        <ng-container matColumnDef="_id">
          <th mat-header-cell *matHeaderCellDef>id</th>
          <td mat-cell *matCellDef="let element">
            {{ element._id }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="spaceDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: spaceDisplayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
